import $ from 'jquery';

function windowPopup(url, width, height) {
  // Calculate the position of the popup so
  // it’s centered on the screen.
  const left = (screen.width / 2) - (width / 2);
  const top = (screen.height / 2) - (height / 2);

  window.open(
    url,
    '',
    `menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=${width},height=${height},top=${top},left=${left}`
  );
}

$('.node-top .social-icons a, .layout-sidebar-first .social-icons a').on('click', function(event) {
  const url = $(this).attr('href');
  const url_array = url.toString().split(/(?:([^:]*):\/\/)?(?:([^:@]*)(?::([^@]*))?@)?(?:([^\\:]*)\.(?=[^.\\:]*\.[^.\\:]*))?([^.\\:]*)(?:\.([^\\.:]*))?(?::([0-9]*))?(\/[^?#]*(?=.*?\/)\/)?([^?#]*)?(?:\?([^#]*))?(?:#(.*))?/);

  if (url_array[1]) {
    event.preventDefault();
    windowPopup(url, 600, 300);
  }
});
